export function normalizeCep(s: string): string | null {
  const d = s.replace(/\D/g, "");
  return d.length === 8 && d !== "00000000" ? d : null;
}

/** Formata "01310100" como "01310-100"; entrada que não é CEP volta sem mudança. */
export function formatCep(cep: string): string {
  const n = normalizeCep(cep);
  return n ? `${n.slice(0, 5)}-${n.slice(5)}` : cep;
}
